import {Fragment, useState} from 'react'
import {useForm} from 'react-hook-form'

import Button from '@mui/material/Button'

import FormWrapper from '../../shared/FormWrapper'
import Input from '../../shared/Input'
import Modal from '../../shared/Modal'

import {connect} from '../../../state/hooks/tools'
import {deleteResource} from '../../../lib/asyncMethods'
import {DELETE_USER} from '../../../state/actionTypes'

const DeleteAccount = props => {
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const methods = useForm()
  const {errors} = methods.formState

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  const handleSubmit = data => {
    setLoading(true)
    console.log(data)

    setTimeout(() => setLoading(false), 1000)
  }

  return (
    <Fragment>
      <Button onClick={toggleModal}>Delete Account</Button>
      <Modal
        disableBackdrop={loading}
        open={showModal}
        handleClose={toggleModal}
        disabled={loading}
        subHeading='Please type "delete" to confirm account deletion'
        buttonText='Done'
        title='Delete Account'>
          <FormWrapper methods={methods} handleSubmit={handleSubmit}>
            <Input
              hideLabel
              error={!!errors.confirmation}
              name='confirmation'
              options={{required: 'Confirmation is required'}}
              helperText={errors.confirmation?.message}
              margin='dense'
            />
            <Button
              disabled={loading}
              type='submit'
              variant='contained'
              color='error'>
              Submit
            </Button>
          </FormWrapper>
      </Modal>
    </Fragment>
  )
}

const actionCreators = ({users}) => ({deleteResource: deleteResource(users, DELETE_USER)})

export default connect(null, actionCreators)(DeleteAccount)
